// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"478":"2570b9d4","527":"aef7f248","782":"fea65f69"}[chunkId] + ".js";
};